/*
 * fn: getClickawayIgnoreProps
 *
 * Gets props for elements to ignore clickaway calls
 *
 */
import { CLICKAWAY_ATTRIBUTE, CLICKAWAY_SCOPES, type ClickawayScopeType } from '@/defs/clickaway'

export type IgnoreClickawayScopesType = ClickawayScopeType[] | 'allScopes'

export const getClickawayIgnoreProps = (scopes: IgnoreClickawayScopesType): Record<string, string> =>
  Object.fromEntries(
    (scopes === 'allScopes' ? CLICKAWAY_SCOPES : scopes).map((scope) => [`${CLICKAWAY_ATTRIBUTE}-${scope}`, '']),
  )
